/* globals Freewall */
;(function ($, window) {
  'use strict'

  window.eah = window.eah || {}

  eah.mosaicGallery = (function () {
    function init () {
      var wall = new Freewall('.gallery--tiled')
      wall.reset({
        selector: '.tile-wrap',
        animate: true,
        cellW: 75,
        cellH: 75,
        gutterX: 10,
        gutterY: 10,
        onResize: function () {
          wall.fitWidth()
        }
      })
      wall.fitWidth()
      $(window).trigger('resize')
    }

    return {
      init: init
    }
  }())

  $(function () {
    eah.mosaicGallery.init()
  })
}(jQuery, window))
